<div class="template-form" id="vendor-layout-template-form">
  <div id="vendor-layout-vendorinfo">
    <div class="col-md srch-area" id="vendor-layout-srch-area">
      <search-vendor [data]="flag" (selectedVendor)="getSelectedVendorInfo($event)" id="vendor-layout-search-vendor"></search-vendor>
      <app-vendor-viewer [data]="vendorData" [update]="update" id="vendor-layout-vendor-viewer"></app-vendor-viewer>
    </div>
  </div>
</div>

